import React, { Component } from 'react'

class MadeBy extends Component {
    render() {
        const { content, css } = this.props

        return (
            <div className="container" style={{ fontSize: '.8em' }}>
                <div className={`row text-center ${css}`}>
                    <div dangerouslySetInnerHTML={{ __html: content }} className="col-lg-12 text-center light_links" />
                </div>
            </div>
        )
    }
}

export { MadeBy }


// WEBPACK FOOTER //
// ./src/components/sections/MadeBy.js